/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Category_Technical_SkillsInputs */

const en_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const de_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const fr_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const es_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const it_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const nl_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const pl_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const fi_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const da_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

const sv_keyword_optimizer_category_technical_skills = /** @type {(inputs: Keyword_Optimizer_Category_Technical_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Skills`)
};

/**
* | output |
* | --- |
* | "Technical Skills" |
*
* @param {Keyword_Optimizer_Category_Technical_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_category_technical_skills = /** @type {((inputs?: Keyword_Optimizer_Category_Technical_SkillsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Category_Technical_SkillsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "fr") return fr_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "es") return es_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "it") return it_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "nl") return nl_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "pl") return pl_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "fi") return fi_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "da") return da_keyword_optimizer_category_technical_skills(inputs)
	if (locale === "sv") return sv_keyword_optimizer_category_technical_skills(inputs)
	return en_keyword_optimizer_category_technical_skills(inputs)
});